import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import {
	WpaArea as SurveyGroup,
	WpaResult as SurveyLite,
} from "../../interfaces/wpa";
import { MOCK_AREAS, MOCK_RESULTS } from "../../mocks/wpa.mocks";
import { WpaBaseService } from "../interfaces/wpa-base.service";

@Injectable({
	providedIn: "root",
})
export class WpaMockService implements WpaBaseService {
	public getResults(): Observable<SurveyLite[]> {
		return of(MOCK_RESULTS);
	}

	public getGroup(
		_surveyId: string,
		areaId: string,
	): Observable<SurveyGroup | undefined> {
		const result = MOCK_AREAS.find((x) => x.id === areaId);
		return of(result);
	}
}
